export default {"src":"https://fishbrain.com/_next/static/media/greyFish.ed9ff1e2.svg","height":66,"width":104,"blurWidth":0,"blurHeight":0};